// extracted by mini-css-extract-plugin
export default {"tooltipMessage":"ProductCardCompareCheckbox_tooltipMessage__PeTDN","portrait":"ProductCardCompareCheckbox_portrait__2IlGm","compact":"ProductCardCompareCheckbox_compact__N-vYJ"};